import React from "react";
import "../../Styles/certified/nutech.css";

export default function nutech() {
  return (
    <>
      <div className="nutech-certified-details-section">
        <div className="nutech-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="nutech-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="nutech-certified-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="nutech-certified-badge"
            />
            <div className="nutech-certified-company-names">
              <a href="https://nutechwindparts.com/" target="_blank" rel="noopener noreferrer">
                <img src="/assets/nutech/nutech.png" alt="Grootan Logo" className="nutech-certified-company-logo" />
              </a>
              <h1 className="nutech-certified-full-name">
                Nutech Wind Parts Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="nutech-certified-details-right">
            <img
              src="/assets/nutech/nu_1.jpeg"
              alt="Grootan Office"
              className="nutech-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="nutech-certified-description">
          <h2>
            Why Nutech Wind Parts Private Limited is a Outstanding Workplaces
          </h2>
          <p>
            NUTECH Wind Parts Pvt Ltd is a reputable wind turbine parts manufacturer that has been committed to providing quality products and services to its customers since 1995. They are dedicated to meeting the needs of their customers, regardless of the size of their orders, and take pride in their ability to develop and supply single-part orders to provide personalized service.
          </p>
          <p>The company recognizes the importance of reducing lead times, particularly in the wind turbine manufacturing industry, where time-to-market can make or break a project's success. Therefore, they maintain an inventory stock of key parts to ensure their customers have access to the components they need when they need them.</p>
          <p>The company has state-of-the-art facilities, including a team of expert engineers and business associates, that enable them to manufacture any component required to design, manufacture, or service wind turbine parts. They have supplied over 10,000 parts across India and globally, offering a one-stop solution to their customers and aiming to provide over 1 lakh parts in the future.</p>
          <p>The company is committed to achieving OEM standards and international quality standards, ensuring indigenization of parts to meet cost-effectiveness and adhering to committed delivery schedules. They continually strive for total customer satisfaction by implementing world-best practices, involving employees, and improving their processes.</p>
          <p>Overall, NUTECH Wind Parts Pvt Ltd is a company that prioritizes its customers' needs and satisfaction. Their dedication to personalized service, fast and efficient delivery, and quality manufacturing sets them apart from other wind turbine parts manufacturers.</p>        
        </div>
        {/* Info Cards Section */}
        <div className="nutech-certified-info-cards">
          <div className="nutech-certified-info-card">
            <div className="nutech-certified-info-title">COMPANY SIZE</div>
            <div className="nutech-certified-info-value">70 Employees</div>
          </div>
          <div className="nutech-certified-info-card">
            <div className="nutech-certified-info-title">INDUSTRY</div>
            <div className="nutech-certified-info-value">MANUFACTURING</div>
          </div>
          <div className="nutech-certified-info-card">
            <div className="nutech-certified-info-title">CONNECT</div>
            <div className="nutech-certified-info-icons">
              <span className="nutech-certified-icon-round">
                <a href="https://nutechwindparts.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="nutech-certified-icon-round">
                <a href="https://www.linkedin.com/company/nutechwindparts/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="nutech-certified-icon-round">
                <a href="https://www.facebook.com/Nutechwindparts/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="nutech-certified-info-card">
            <div className="nutech-certified-info-title">LOCATION (HQ)</div>
            <div className="nutech-certified-info-value">Chennai, Tamil Nadu.</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="nutech-certified-recognition-section">
          <h2 className="nutech-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="nutech-certified-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="nutech-certified-recognition-image"
            />
          </div>
          <div className="nutech-certified-recognition-label">
            Outstanding Workplaces -  Certified
          </div>
        </div>
        {/* Life at Grootan Section */}
        <div className="nutech-certified-life-section">
          <h2 className="nutech-certified-life-title">
            Life at Nutech Wind Parts Private Limited
          </h2>
          <div className="nutech-certified-life-gallery">
            <div className="nutech-certified-life-col">
              <img src="/assets/nutech/nu_2.jpeg" alt="Office 1" className="nutech-certified-life-img" />
              <img src="/assets/nutech/nu_3.jpeg" alt="Meeting 1" className="nutech-certified-life-img" />
            </div>
            <div className="nutech-certified-life-col nutech-certified-life-center">
              <img src="/assets/nutech/nu_5.jpeg" alt="Main Office" className="nutech-certified-life-img nutech-certified-life-img-large" />
            </div>
            <div className="nutech-certified-life-col">
              <img src="/assets/nutech/nu_6.jpeg" alt="Office 2" className="nutech-certified-life-img" />
              <img src="/assets/nutech/nu_7.jpeg" alt="Meeting 2" className="nutech-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}